export const postFiltersPreferencesAdapter = ({
  idsServicios,
  idsProveedores,
  idsContratos,
  unidadesNegocioIds,
  operacionesIds,
  ...filters
}) => ({
  asinacionEvento: filters.asignacionEventoEnum,
  numeroSolicitud: null,
  numeroSolicitudServicio: filters?.numeroSolicitud || [],
  servicios: idsServicios?.length ? idsServicios : [],
  proveedores: idsProveedores?.length ? idsProveedores : [],
  contratos: idsContratos?.length ? idsContratos : [],
  fechaHasta: filters.fechaHasta || null,
  fechaDesde: filters.fechaDesde || null,
  tipoUbicacionEnum: filters.tipoUbicacionEnum || null,
  ubicacion: filters.ubicacion || null,
  eventos: filters.idEvento || [],
  equipoDeTorre: filters.equipo || [],
  usuarioCreador: filters.idUsuarioCreador || null,
  prioridad: filters.idPrioridad
    ? { id: filters.idPrioridad.id, nombre: filters.idPrioridad.nombre }
    : null,
  unidadesNegocio: unidadesNegocioIds?.length
    ? unidadesNegocioIds.map((unidad) => ({
        id: unidad.id,
        nombre: unidad.nombre
      }))
    : [],
  operaciones: operacionesIds?.length
    ? operacionesIds.map((operacion) => ({ id: operacion.id, nombre: operacion.nombre }))
    : [],
  estadosEnums: filters?.estadosEnums?.length
    ? filters.estadosEnums.map((status) => ({ id: status.id, nombre: status.nombre }))
    : []
});

export const postFilterPreferenceApproverAdapter = ({
  idsServicios,
  idsProveedores,
  idsContratos,
  operacionesIds,
  ...filters
}) => ({
  idUsuario: filters.idUsuario || null,
  numerosContrato: filters.numerosContrato || null,
  numeroSolicitud: filters.numeroSolicitud || null,
  equipo: filters.equipo
    ? {
        id: filters.equipo.id,
        nombre: filters.equipo.nombre
      }
    : null,
  servicios: idsServicios.length
    ? idsServicios.map((servicio) => ({
        id: servicio.id,
        nombre: servicio.nombre
      }))
    : null,
  proveedores: idsProveedores.length
    ? idsProveedores.map((proveedor) => ({
        id: proveedor.id,
        nombre: proveedor.nombre
      }))
    : null,
  tipoEvento: filters.evento
    ? {
        id: filters.evento.id,
        nombre: filters.evento.nombre
      }
    : null,
  tipoUbicacionEnum: filters.tipoUbicacionEnum
    ? {
        id: filters.tipoUbicacionEnum.id,
        nombre: filters.tipoUbicacionEnum.nombre
      }
    : null,
  ubicacion: filters?.ubicacion
    ? {
        id: filters.ubicacion.id,
        nombre: filters.ubicacion.nombre
      }
    : null,
  unidadesNegocio: filters.unidadesNegocioIds?.length
    ? filters.unidadesNegocioIds.map((unidad) => ({
        id: unidad.id,
        nombre: unidad.nombre
      }))
    : [],
  operaciones: operacionesIds?.length
    ? operacionesIds.map((operacion) => ({ id: operacion.id, nombre: operacion.nombre }))
    : [],
  contratos: idsContratos?.length
    ? idsContratos.map((contrato) => ({ id: contrato.id, nombre: contrato.nombre }))
    : []
});

export const postFilterPreferenceDetailSDSAdapter = (filters) => {
  const { posicionesLineas } = filters;

  return {
    posicionesLineas: posicionesLineas?.map((linePos) => ({
      posicion: linePos?.posicion,
      posicionId: linePos?.posicionId,
      linea: linePos?.linea,
      lineaId: linePos?.lineaId,
      label: linePos?.label
    }))
  };
};

export const postFilterPreferencesDetailMSDSAdapter = (filters) => {
  const fil = {
    equiposIds: filters?.towerEquipments?.map((equip) => equip.id) || [],
    eventosIds: filters?.events.map((evnt) => evnt.id) || [],
    tipoUbicacionesIds: filters?.ubicationType ? [filters?.ubicationType?.id] : [],
    ubicacionesIds: filters?.ubications ? [filters?.ubications?.id] : [],
    posicionesLineas:
      filters?.posicionesLineas?.map((pos) => ({
        posicion: pos?.posicion,
        posicionId: pos?.posicionId,
        linea: pos?.linea,
        lineaId: pos?.lineaId,
        label: pos?.label
      })) || []
  };

  return fil;
};
